export const LOGIN_TYPE = {
  web: 'web',
  app: 'app',
};

export const MOBILE_ALERT_TYPE = {
  first: 1,
  second: 2,
};

export default {
  LOGIN_TYPE,
  MOBILE_ALERT_TYPE,
};
